import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const BackdropDriftAmplitudeXListItem = (props) => {
    const { amplitudeX, updateBackgroundSettings } = props;

    const onAmplitudeXChange = (value) => {
        updateBackgroundSettings({ drift: { amplitudeX: value } });
    };

    return (
        <SliderListItem
            title='X Distance'
            displayMultiplier={2}
            value={amplitudeX}
            min={0}
            max={100}
            step={1}
            onValueChange={onAmplitudeXChange}
            toolTip='Horizontal movement distance.'
        />
    );
};

const mapStateToProps = (state) => {
    const { amplitudeX } = state.createPreview.present.videoSettings.background.drift;
    return { amplitudeX };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropDriftAmplitudeXListItem);
